/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/ChallengeManager',[
    'absolute/storagemanager'],
    function (StorageManager) {
    "use strict";

    var ChallengeManager = {

        _storageKey: "ChallengeManagerStore",

        _cache: null,

        // workaround for bug in MS data files
        _dupeList: ["5fb4bf8-a71c-41eb-a947-466dc32cca5d", "744350d3-36f2-4b27-a14c-ab823112853f",
            "d8b84c76-86f5-4071-a5f6-7b1395336c8c", "23cc01ac-83a3-4fca-ae25-7525a871f85b",
            "75fb4bf8-a71c-41eb-a947-466dc32cca5d"],

        _dupeTrack: {},

        StoreChallenge: function (challengeConfig) {
            if (!this._cache) {
                this._cache = StorageManager.fetch(this._storageKey);

                if (!this._cache) {
                    this._cache = {};
                }
            }

            var Key = challengeConfig.Key || challengeConfig.ID;

            if (!this._cache[Key]) {
                this._cache[Key] = challengeConfig;
            }
            else if (this._dupeList.indexOf(Key) != -1) {
                if (!this._cache[Key + "_ALLOW_DUPE"]) {
                    Key = Key + "_ALLOW_DUPE";
                    challengeConfig.Key = Key;
                    this._cache[Key] = challengeConfig;
                }
            }

            return Key;

        },

        StoreChallengePack: function (challengePackConfig) {
            if (!this._cache) {
                this._cache = StorageManager.fetch(this._storageKey);

                if (!this._cache) {
                    this._cache = {};
                }
            }

            if (!this._cache[challengePackConfig.ID]) {
                this._cache[challengePackConfig.ID] = challengePackConfig;
            }
        },

        Sync: function () {
            StorageManager.store(this._storageKey, this._cache);
        },

        SetChallengePlayed: function (Key, value) {
            var challengeConfig = this._cache[Key];
            if (challengeConfig) {
                challengeConfig.Played = value;
                StorageManager.store(this._storageKey, this._cache);
            }
        },

        IsChallengePlayed: function (Key) {
            var challengeConfig = this._cache[Key];
            if (challengeConfig) {
                return challengeConfig.Played || false;
            }
            return false;
        },

        SetChallengeCompleted: function (Key, value) {
            var challengeConfig = this._cache[Key];
            if (challengeConfig) {
                challengeConfig.Completed = value;
                StorageManager.store(this._storageKey, this._cache);
            }
        },

        IsChallengeCompleted: function (Key) {
            var challengeConfig = this._cache[Key];
            if (challengeConfig) {
                return challengeConfig.Completed;
            }
            return false;
        },

        GetChallengeConfig: function (Key) {
            if (!this._cache) {
                this._cache = StorageManager.fetch(this._storageKey);

                if (!this._cache) {
                    this._cache = {};
                }
            }

            return this._cache[Key];
        },

        IsChallengePackUnlocked: function (Key) {
            var challengePackConfig = this._cache[Key];
            if (challengePackConfig) {
                return challengePackConfig.Unlocked || false;
            }
            return false;
        },

        SetChallengePackUnlocked: function (Key, value) {
        var challengePackConfig = this._cache[Key];
            if (challengePackConfig) {
                challengePackConfig.Unlocked = value;
                StorageManager.store(this._storageKey, this._cache);
            }
        },

        GetChallengePackConfig: function (Key) {
            return this._cache[Key];
        },

        IsChallengeCollectionUnlocked: function (Key) {
            var challengeCollectionConfig = this._cache[Key];
            if (challengeCollectionConfig) {
                return challengeCollectionConfig.Unlocked || false;
            }
            return false;
        },

        SetChallengeCollectionUnlocked: function (Key, value) {
            var challengeCollectionConfig = this._cache[Key];
            if (challengeCollectionConfig) {
                challengeCollectionConfig.Unlocked = value;
                StorageManager.store(this._storageKey, this._cache);
            }
        },

        GetChallengeCollectionConfig: function (Key) {
            return this._cache[Key];
        }

    };

    return ChallengeManager;
});

